var map = {
	"./m1.jpg": 75,
	"./m2.jpg": 1943,
	"./m3.jpg": 8174,
	"./m4.jpg": 3077,
	"./m5.jpg": 829,
	"./m6.jpg": 2499,
	"./m7.jpg": 8393,
	"./m8.jpg": 9125,
	"./m9.jpg": 8684
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 694;